import { render, staticRenderFns } from "./hospitalExamineReport.vue?vue&type=template&id=1dd80040&scoped=true"
import script from "./hospitalExamineReport.vue?vue&type=script&lang=js"
export * from "./hospitalExamineReport.vue?vue&type=script&lang=js"
import style0 from "./hospitalExamineReport.vue?vue&type=style&index=0&id=1dd80040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd80040",
  null
  
)

export default component.exports